import logo from "../data/logo.png";
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <a href="#home" className="brand">
            <span className="brand-text">
              <span className="brand-name">Zafwa Royale</span>
              <span className="brand-sub">Events Management LLC</span>
            </span>
          </a>
          <p>
            Regal event design and planning for weddings, galas and celebrations
            that deserve a crown.
          </p>
        </div>

        <div className="footer-links">
          <h4>Explore</h4>
          <a href="#home">Home</a>
          <a href="#about">About Us</a>
          <a href="#events">Events</a>
          <a href="#reviews">Reviews</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer-contact">
          <h4>Reach Us</h4>
          <a href="mailto:admin@zafwaroyaleevents.online">
            admin@zafwaroyaleevents.online
          </a>
          <a href="tel:+919876543210">+97143232186</a>
          <span>
            #702 7th floor Al waleed Building Al Rolla Street Bur Dubai
          </span>
        </div>
      </div>
      <div className="footer-bottom container">
        <span>
          © {year} Zafwa Royale Events Management LLC. All rights reserved.
        </span>
        <span>Crafted with care for occasions worth celebrating.</span>
      </div>
    </footer>
  );
}
